import * as Yup from "yup";

export const createPromoCodeSchema = Yup.object().shape({
  code: Yup.string()
    .required("Promo code is required")
    .min(3, "Promo code must be at least 3 characters")
    .max(10, "Promo code must not exceed 10 characters")
    .matches(/^[A-Z0-9]+$/i, "Promo code must contain only letters and numbers"),

  // code: Yup
  //   .string()
  //   .required("Promo code is required")
  //   .trim("Promo Code should not have leading or trailing spaces.")
  //   .min(3, "Promo Code must be at least 3 characters."),
    
  amount: Yup.number()
    .required("Amount is required")
    .positive("Amount must be a positive number")
    .min(0.01, "Amount must be at least 0.01"),


  validity: Yup.date()
    .required("Validity date is required")
    .min(new Date().toISOString().split('T')[0], "Validity date must be today or in the future"),

  status: Yup.boolean()
});